export default class VueFilter {
  static numberFormat(val: number): string {
    return val.toLocaleString()
  }
}
